import React from 'react'
import Icons from '../../assets/icons'

const SortingCustomIcon = (order, row) => {
	return (
		<span className='pointer order-arrow d-flex flex-column'>
			{order === 'asc' && (
				<span className='arrow-up'>
					<img
						src={Icons.UpArrow}
						alt='caret-icon'
						className='opacity-50 upArrow d-block mb-1'
						width='10'
					/>
				</span>
			)}
			{order === 'desc' && (
				<span className='arrow-down'>
					<img
						src={Icons.DownArrow}
						alt='caret-icon'
						className='opacity-50 d-block'
						width='10'
					/>
				</span>
			)}
			{!order && (
				<span className='sort-icon'>
					<img
						src={Icons.Sort}
						alt='caret-icon'
						className='opacity-50 d-block'
						width='12'
					/>
				</span>
			)}
		</span>
	)
}
export default SortingCustomIcon
